var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.title !== ""
      ? _c("div", {
          staticClass: "candy-bar-title col-12 text-center my-3",
          domProps: { textContent: _vm._s(_vm.title) }
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.slideCount > 0
      ? _c(
          "div",
          { staticClass: "d-flex justify-content-center" },
          [
            _c(
              "b-carousel",
              {
                staticClass: "w-100",
                class: {
                  "no-indicator": _vm.slideCount === 1
                },
                attrs: {
                  interval: 5000,
                  controls: !_vm.isMobile,
                  indicators: _vm.isMobile
                }
              },
              [
                _vm.isLoading && _vm.productList.length === 0
                  ? _c("b-carousel-slide", {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "img",
                            fn: function() {
                              return _vm._l(4, function(skeletonIndex) {
                                return _c("product-box", {
                                  key: "skeletonIndex_" + skeletonIndex,
                                  class: _vm.getBootstrapColumnWidthClass(1),
                                  attrs: { "is-loading": _vm.isLoading }
                                })
                              })
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        4285992099
                      )
                    })
                  : _vm._l(_vm.slideCount, function(currentSlide) {
                      return _c("b-carousel-slide", {
                        key: currentSlide,
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "img",
                              fn: function() {
                                return _vm._l(
                                  _vm.getCurrentProductBoxList(currentSlide),
                                  function(product) {
                                    return _c("product-box", {
                                      key: product.id,
                                      class: _vm.getBootstrapColumnWidthClass(
                                        currentSlide
                                      ),
                                      attrs: {
                                        product: product,
                                        "cart-button-only-icon":
                                          _vm.cartButtonOnlyIcon,
                                        "is-loading": _vm.isLoading
                                      }
                                    })
                                  }
                                )
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        )
                      })
                    })
              ],
              2
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }